export default {
  congrats: require('../sounds/congrats.mp3'),
  locked: require('../sounds/locked.mp3'),
  negative: require('../sounds/negative-feedback.mp3'),
  noSelectedAnswer: require('../sounds/no-selected-answer-feedback.mp3'),
  positive: require('../sounds/positive-feedback.mp3'),
  unlocked: require('../sounds/unlocked.mp3')
}
